// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { downRightFromSquare16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-down-right-from-square': IconDownRightFromSquare;
    }
}

/**
 * The icon component for the 'downRightFromSquare' icon
 */
export class IconDownRightFromSquare extends Icon {
    public constructor() {
        super(downRightFromSquare16X16);
    }
}

registerIcon('icon-down-right-from-square', IconDownRightFromSquare);
export const iconDownRightFromSquareTag = 'nimble-icon-down-right-from-square';
